import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {Subscription} from "rxjs";
import {AuthService} from "@auth0/auth0-angular";
import {jwtDecode} from "jwt-decode";
import {JsonPipe} from "@angular/common";
import {LoadingComponent} from "../../shared/loading/loading.component";

@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [JsonPipe, LoadingComponent],
  templateUrl: './debug.component.html',
  styleUrl: './debug.component.less'
})
export class DebugComponent implements OnInit, OnDestroy {
  loading = signal(true);
  authenticated = signal(false);
  userInfo: any;
  private subscription = new Subscription();

  constructor(private authService: AuthService) {
  }

  ngOnInit() {
    console.log('==> Login App: Debug Init');
    this.subscription.add(
      this.authService.getAccessTokenSilently().subscribe({
        next: (jwtToken) => {
          this.userInfo = jwtDecode(jwtToken);
          this.authenticated.set(true);
          this.loading.set(false);
        }, error: (error) => {
          console.log('==> Login App: Unable to fetch token');
          this.loading.set(false);

          if (error?.message !== "Login required") {
            console.error('LOGIN: 🚫 - Error retrieving access token', error);
          }
        }
      })
    );
  }

  logout() {
    this.authService.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
